<template>
  <div>
    <Documents />
  </div>
</template>

<script>
import Documents from '../Documents';

export default {
  components: {
    Documents: Documents,
  },
  name: 'Tab7',
  data() {
    return {
      Info: {},
    };
  },
  created() {},
  mounted() {
    this.Info = this.$attrs.Info;
  },
};
</script>
